import { FC, FormEvent, useState } from 'react'
import { useMailman } from '../../utils'
import { StyledAdminView } from '.'

const AdminView: FC = () => {
  const { mailman } = useMailman()
  const [currency, setCurrency] = useState('CAD')
  const [value, setValue] = useState<number>()
  const [address, setAddress] = useState('')
  const [city, setCity] = useState('Toronto')
  const [state, setState] = useState('Onario')
  const [country, setCountry] = useState('Canada')
  const [tour, setTour] = useState('')

  const newMap = async (e: FormEvent) => {
    e.preventDefault()
    await mailman(`homes`, 'POST', {
      currency,
      value,
      address,
      city,
      state,
      country,
      tour
    })

    setCurrency('CAD')
    setValue(0)
    setAddress('')
    setCity('Toronto')
    setState('Ontario')
    setCountry('Canada')
    setTour('')
  }

  return (
    <StyledAdminView>
      <form onSubmit={(e) => newMap(e)}>
        <input
          type="text"
          placeholder="Currency"
          value={currency}
          onChange={(e) => setCurrency(e.target.value)}
        />
        <input
          type="number"
          placeholder="Value"
          value={value}
          onChange={(e) => setValue(parseInt(e.target.value))}
        />
        <input
          type="text"
          placeholder="Address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
        />
        <input
          type="text"
          placeholder="City"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />
        <input
          type="text"
          placeholder="State"
          value={state}
          onChange={(e) => setState(e.target.value)}
        />
        <input
          type="text"
          placeholder="Country"
          value={country}
          onChange={(e) => setCountry(e.target.value)}
        />
        <input
          type="text"
          placeholder="Tour"
          value={tour}
          onChange={(e) => setTour(e.target.value)}
        />
        <button
          disabled={!currency.trim() || !address.trim() || !city.trim() || !state.trim() || !country.trim() || !tour.trim()}
        >
          Add Home
        </button>
      </form>
    </StyledAdminView>
  )
}

export default AdminView
